// setHasScrollHintDisplayed.js
'use strict';
import { MERGE_ME_DATA } from '../ActionTypes.js';
import getMeData from '../selector/getMeData.js';

/**
 * Set has displayed livestream scroll hint UI ever
 * @kind action
 * @return {Promise} Action promise.
 */
const setHasScrollHintDisplayed = () => async (dispatch, getState) => {
  const hasScrollHintDisplayed = getMeData(
    getState(),
    'hasScrollHintDisplayed'
  );
  if (hasScrollHintDisplayed) return dispatch({ type: '' });

  return dispatch({
    type: MERGE_ME_DATA,
    payload: {
      hasScrollHintDisplayed: true,
    },
  });
};

export default setHasScrollHintDisplayed;
